/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SecurityRolesManager {
    angular.module("meevo.plugins.securityRolesManager", []);
}